export let kvMovie = {
	resize: function( beforeW ){
		const videoElement 	= document.getElementById('kv_video');
		const videoSource 	= document.getElementById('kv_video_source');
		if( videoElement ){
			const vSource = [
				'https://pub-d00b549445fb4341bdcf36e20b460c0d.r2.dev/movie/kv_sp.mp4',
				'https://pub-d00b549445fb4341bdcf36e20b460c0d.r2.dev/movie/kv_pc.mp4'
			];
			
			function setVideoSource() {
				const width = window.innerWidth;
				let newSource;
				if (width <= 1071) {
					newSource = vSource[0];
				} else if (width >= 1072) {
					newSource = vSource[1];
				}
				if( width != beforeW ){
					//console.log(vSource, newSource);
					if (videoSource.src !== newSource) {
						videoSource.src = newSource;
						videoElement.load(); // 新しいソースを読み込む
						kvMovie.nav();
						setTimeout(function(){
							let $wrap = document.querySelector(".c-fv_movie");
							if( $wrap.classList.contains("disable") ){
								$wrap.classList.remove("disable");
							}
						}, 100);
						/*
						videoElement.addEventListener('playing', () => {
							videoElement.classList.add('is-playing');
						}, { once: true });
						*/
					}
				}
			
			}
			setVideoSource();
		}
	},
	pause: function(){
		let $video = document.querySelector("#kv_video");
		$video.pause();
	},
	play: function(){
		let $video = document.querySelector("#kv_video");
		if( $video.paused ){
			$video.play();
		}
	},
	nav: function(){
		let $btnSound = document.querySelector(".c-fv_movie button[data-toggle-sound]");
		$btnSound.removeEventListener("click", kvMovie.toggleMute, false);
		$btnSound.addEventListener("click", kvMovie.toggleMute, false);
	},
	toggleMute: function(e){
		e.preventDefault();
		let $btn = e.currentTarget;
		$btn.classList.toggle("sound-on");
		let $video = document.querySelector("#kv_video");
		if( !$video ) return;
		$video.muted = !$video.muted;
		
		return $video.muted; // 現在の状態を返す（ボタン表示の更新などに使える）
	}
}